// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideShieldCheck as RawLucideShieldCheck } from "lucide-react";
export const LucideShieldCheck = /* @__PURE__ */ createIcon(RawLucideShieldCheck, "LucideShieldCheck", 2);
